module.exports = __webpack_public_path__ + "static/SquareSerif-Bold-webfont-ccaac6f23c55658b4192aa081cb3bb51.woff";